import { useIntl } from '@weenat/wintl';
import isNil from 'lodash-es/isNil';
import { useClient } from '../../../ClientProvider';
import useConvertedValue from '../../../hooks/useConvertedValue';
import useQuery from '../../../useQuery';
import { getAggregateValue } from '../../summary';
const metric = 'LW_V';
const secondaryMetric = 'LW_D';
export const useLeafWetnessSummary = ({ plotId }) => {
    const { t } = useIntl();
    const { convertNumberValue } = useConvertedValue();
    const client = useClient();
    const summary = useQuery(client.measurements.plots.summaries.getOne({ plotId })).data?.data;
    const currentIntensity = getAggregateValue(metric, 'latest', summary);
    const convertedCurrentIntensity = convertNumberValue({ metric, value: currentIntensity.value });
    const hasKnownIntensity = currentIntensity && !isNil(currentIntensity.value);
    const currentFlag = hasKnownIntensity && !isNil(convertedCurrentIntensity)
        ? t(`dss.leafWetness.flags.${convertedCurrentIntensity < 1 ? 'dry' : 'wet'}`, {
            capitalize: true
        })
        : undefined;
    const lastTwelveHours = getAggregateValue(secondaryMetric, 'lastTwelveHours', summary);
    return {
        currentFlag,
        lastTwelveHours,
        metric,
        currentIntensity
    };
};
